export default __webpack_public_path__ + "static/media/distanstolkning13.f4f8d805.png";